<template>

  <MarketHeader
    selectedHeader="defaultHeader"
    />

  <main>
    <LayoutSection
      sectionClass="next_appointments_sidebar"
      paddingClass="py-8"
      :maxWidthClass="'w-full'"
    >
      <div class="flex flex-wrap gap-2 mb-6 xl:hidden overflow-auto no-scrollbar">
        <AppButton
          v-for="tab in tabs"
          :key="tab.id"
          :to="tab.route"
          variant="secondary"
          class="account-tab px-2.5 py-2 whitespace-nowrap leading-tight"
          :class="{ 'font-bold border-black': isActive(tab.route) }"
        >
          {{ tab.label }}
        </AppButton>
      </div>

      <div class="xl:flex appointments_gap">
        <div class="hidden xl:block xl:w-1/4 xl:px-6">
          <AccountSidebar />
        </div>
        <div class="w-full xl:w-3/4 xl:px-6">
          <div class="tab-content pb_25">
            <div class="tab-pane opacity-0 opacity-100 block active" id="tab1" role="tabpanel">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </LayoutSection>
  </main>

	<BackGround/>

</template>

<script lang="ts">

import BackGround from '@/components/design/background.vue';
import { defineComponent } from "vue";
import MarketHeader from '@/components/header/header.vue';
import AccountSidebar from '@/components/account/accountSidebar.vue';
import AppButton from '@/components/buttons/AppButton.vue';
import LayoutSection from '@/components/design/layoutSection.vue';

export default defineComponent({
  name: "AccountLayout",
  components: {
    MarketHeader,
    AccountSidebar,
		BackGround,
    AppButton,
    LayoutSection
  },
  computed: {
    tabs() {
      const baseTabs = [
        { id: 'tab1', route: '/account/upcoming-appointments', label: this.$t('Upcoming Appointments') },
        { id: 'tab2', route: '/account/past-appointments', label: this.$t('Past Appointments') },
        { id: 'tab3', route: '/account/favorite-specialists', label: this.$t('Favorite Specialists') },
        { id: 'tab4', route: '/account/settings', label: this.$t('Account Settings') },
      ];
      const shouldShowFavoriteSpecialists = false;
      return shouldShowFavoriteSpecialists ? baseTabs : baseTabs.filter((tab) => tab.id !== 'tab3');
    }
  },
  methods: {
    isActive(route: string) {
      return this.$route.path === route;
    }
  }
});
</script>

<style scoped>

@import "../assets/css/helper.css";
@import "../assets/css/style.css";
@import "../assets/css/responsive.css";

.appointments_gap {
	--bs-gutter-x: 3.2rem;
}

.no-scrollbar {
	scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
	display: none;
}

:deep(.account-tab) {
	font-size: 12px !important;
}
@media (min-width: 768px) {
	:deep(.account-tab) {
		font-size: 14px !important;
	}
}
@media (min-width: 1024px) {
	:deep(.account-tab) {
		font-size: 18px !important;
	}
}
@media (min-width: 1280px) {
	:deep(.account-tab) {
		font-size: 24px !important;
	}
}

</style>
